<template>
  <v-card class="pa-2 mb-2" flat style="border-radius: 10px;">
    <v-layout row>
      <v-avatar size="45" class="mt-1 ml-1">
        <v-img
          :src="user.avatar"
        />
      </v-avatar>
      <span class="ml-3 pt-1" style="font-size: 17px;">{{ user.name }}<br>Bid: &#8377;{{user.bid}}</span>
      <v-layout justify-end row>
        <v-btn fab small color="success" outline @click="acceptBid" :loading="loading">
          <v-icon>fa fa-check</v-icon>
        </v-btn>
        <v-btn fab small color="error" outline @click="rejectBid" :loading="loading2">
          <v-icon>fa fa-times</v-icon>
        </v-btn>
      </v-layout>
    </v-layout>
  </v-card>
</template>

<script>
import firebase from 'firebase'
export default {
  data() {
    return{
      loading: false,
      loading2: false
    };
  },
  props: {
    user: Object,
    postId: String
  },

  methods: {
    acceptBid (){
      this.loading = true;
      const db = firebase.firestore();
      var vm = this;
      var newInterested = [], newAccepted = [], deleteIndex, userInterested = [], userAccepted = [], deleteUserIndex, full = false;
      db.collection('posts_buy').doc(vm.postId).get()
      .then(function(doc){
        newInterested = doc.data().interested;
        newAccepted = doc.data().accepted;
        newInterested.forEach(function(item, index){
          if(item.uid == vm.user.uid){
            deleteIndex = index;
          }
        });
        newInterested.splice(deleteIndex,1);
        db.collection('users').doc(vm.user.uid).get()
        .then(function(userDoc){
          newAccepted.push({
            uid: userDoc.id,
            name: userDoc.data().name,
            bid : Number(vm.user.bid),
            avatar: userDoc.data().avatar,
            email: userDoc.data().email,
            contact: userDoc.data().contact
          });
          userInterested = userDoc.data().interested;
          userAccepted = userDoc.data().accepted_buy;
          userInterested.forEach(function(item, index){
            if(item.id == vm.postId){
              deleteUserIndex = index;
            }
          });
          userInterested.splice(deleteUserIndex,1);
          userAccepted.push({
            id : vm.postId,
            bid : Number(vm.user.bid)
          });
          db.collection('posts_buy').doc(vm.postId).update({
            interested: newInterested,
            accepted: newAccepted,
          })
          .then(function(){
            db.collection('users').doc(vm.user.uid).update({
              interested : userInterested,
              accepted_buy : userAccepted
            })
          })
        });
      })
      .catch(function (error) {
        vm.loading = false;
      });
    },
    rejectBid(){
      this.loading2 = true;
      const db = firebase.firestore();
      var vm = this;
      var newInterested=[], userInterested = [];
      var deleteIndex, deleteUserIndex;
      db.collection('posts_buy').doc(vm.postId).get()
      .then(function(doc){
        newInterested=doc.data().interested;
        newInterested.forEach( function(element, index) {
          if(element.uid==vm.user.uid){
            deleteIndex = index;
          }
        });
        newInterested.splice(deleteIndex,1);
        db.collection('users').doc(vm.user.uid).get()
        .then(function (userDoc) {
          userInterested=userDoc.data().interested;
          userInterested.forEach( function(element, index) {
            if(element.id=vm.postId){
              deleteUserIndex = index;
            }
          });
          userInterested.splice(deleteUserIndex,1);
          db.collection('posts_buy').doc(vm.postId).update({
            interested : newInterested,
          })
          .then(function () {
            db.collection('users').doc(vm.user.uid).update({
              interested : userInterested
            })
          })
        })
      }).catch(function (error) {
        vm.loading2 = false;
      })
    }
  }
};
</script>